import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import VueRouter from 'vue-router'
import routes from './routes.js'
import VueMeta from 'vue-meta'
import i18n, { SUPPORTED } from './i18n'
import { restoreSessionFromCookies, getSession, bootstrapSharedSession } from './services/nukliApi'

import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';

import './assets/styles/global.css'
import './assets/styles/landing.css'

import VueCookies from 'vue-cookies'

import LIcon from './components/LIcon.vue'

Vue.config.productionTip = false
Vue.component('LIcon', LIcon)
Vue.component('l-icon', LIcon)
Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash, behavior: 'smooth' };
    }
    return savedPosition || { x: 0, y: 0 };
  },
})

const DEFAULT_LOCALE = 'en';

function applyLocale(code) {
  if (i18n.locale !== code) i18n.locale = code;
  if (typeof document !== 'undefined') document.documentElement.lang = code;
}

// Una URL por idioma: "/" (+ rutas sin prefijo) = inglés por defecto; "/es", "/ca"…
// para el resto. El prefijo se preserva automáticamente en cada navegación, así
// los enlaces internos (sin prefijo) no hace falta reescribirlos.
router.beforeEach((to, from, next) => {
  if (to.fullPath.substr(0, 2) === '/#') {
    next(to.fullPath.substr(2));
    return;
  }

  const lang = to.params.lang;
  if (lang) {
    if (lang === DEFAULT_LOCALE) {
      const stripped = to.fullPath.replace(/^\/en(?=\/|$)/, '') || '/';
      next({ path: stripped, query: to.query, hash: to.hash, replace: true });
      return;
    }
    if (!SUPPORTED.includes(lang)) {
      next('/404');
      return;
    }
    applyLocale(lang);
    next();
    return;
  }

  const active = i18n.locale;
  if (active && active !== DEFAULT_LOCALE && SUPPORTED.includes(active)) {
    next({ path: '/' + active + (to.path === '/' ? '' : to.path), query: to.query, hash: to.hash });
    return;
  }
  applyLocale(DEFAULT_LOCALE);
  next();
});

// Guard de rutas autenticadas (meta.requiresAuth). En la carga inicial este
// guard puede ejecutarse antes del `mounted` raíz que restaura la sesión, así
// que aquí intentamos rehidratar desde cookies antes de decidir el redirect.
router.beforeEach((to, from, next) => {
  if (!to.matched.some((r) => r.meta && r.meta.requiresAuth)) {
    next();
    return;
  }
  if (!getSession().isAuthenticated && Vue.prototype.$cookies) {
    restoreSessionFromCookies(Vue.prototype.$cookies);
  }
  const decide = () => {
    if (getSession().isAuthenticated) {
      next();
      return;
    }
    next({ name: 'Login', params: { lang: to.params.lang }, query: { redirect: to.fullPath } });
  };
  if (!getSession().isAuthenticated) {
    // Puede haber sesión iniciada en mail.nukliapp.com: la cookie compartida se
    // canjea antes de mandar a nadie al login.
    bootstrapSharedSession().then(decide, decide);
    return;
  }
  decide();
});

Vue.use(VueMeta, { refreshOnceOnNavigation: true })
Vue.use(Toast, {});
Vue.use(VueCookies);
Vue.prototype.$cookies.config('30d', '', '', true)

// El idioma se deriva de la URL (ver router.beforeEach). Por defecto: inglés.
i18n.locale = 'en'
document.documentElement.lang = 'en'

const darkMode = Vue.prototype.$cookies.get('darkMode') === 'true'
  || (Vue.prototype.$cookies.get('darkMode') == null && window.matchMedia('(prefers-color-scheme: dark)').matches)

new Vue({
  i18n,
  data() {
    return {
      nukliUser: null,
      currentLanguage: i18n.locale,
      isDark: darkMode,
    }
  },
  vuetify,
  router,
  render: h => h(App),
  mounted() {
    restoreSessionFromCookies(this.$cookies);
    const session = getSession();
    if (session.user) this.nukliUser = session.user;
    // Sesión compartida con la app web (mail.nukliapp.com): si allí hay sesión,
    // aquí aparece ya iniciada, y al revés (ver services/sso.js).
    bootstrapSharedSession().then(() => {
      const shared = getSession();
      this.nukliUser = shared.isAuthenticated ? shared.user : null;
    }).catch(() => {});
    this.$vuetify.theme.dark = this.isDark;
  },
}).$mount('#app')


